const el = {
    common: {
        history: "ιστορική εκδοχή"
    }
};
export default el;



// WEBPACK FOOTER //
// ./src/i18n/langs/el.js